module.exports = __webpack_public_path__ + "media/wd-siteH264.7c5f65ab.mp4";